import { ConsumerLoan } from "modules/term-loan/ConsumerLoan";
import React from "react";

const TermLoan: React.FC = () => {
  return <ConsumerLoan />;
};

export default TermLoan;
